<template>
    <div class="payment-methods">
        <h3 class="section-title">
            {{ $i18n.t("subscription.checkout_page_payment_method_title") }}
        </h3>
        <div v-if="false" class="payment-method" :class="{ selected: selectedMethod === 'wechat' }" @click="selectMethod('wechat')">
            <strong>
            {{ $i18n.t("subscription.checkout_page_payment_Wechat") }}
        </strong> - 
            {{ $i18n.t("subscription.checkout_page_payment_method_qr_code") }}
        </div>
        <div v-if="false" class="payment-method" :class="{ selected: selectedMethod === 'alipay' }" @click="selectMethod('alipay')">
            <strong>
                {{ $i18n.t("subscription.checkout_page_payment_Alipay") }}
            </strong> - 
            {{ $i18n.t("subscription.checkout_page_payment_method_qr_code") }}
        </div>
        <div class="payment-method" disabled :class="{ selected: selectedMethod === 'stripe' }" @click="selectMethod('stripe')">
        <!-- <div class="payment-method disabled"> -->
            <strong>
                {{ $i18n.t("subscription.checkout_page_payment_Stripe") }}
            </strong>
             <!-- -  -->
            <!-- {{ $i18n.t("subscription.checkout_page_payment_method_coming_soon") }} -->
        </div>
        <!-- <div class="payment-method disabled">
            <strong>
                {{ $i18n.t("subscription.checkout_page_payment_Bank") }}
            </strong> - 
            {{ $i18n.t("subscription.checkout_page_payment_method_coming_soon") }}
        </div> -->
    </div>
</template>

<script>
import { PaymentType } from '@/store/modules/enums';
export default {
    name: 'PaymentMethod',
    props: {
        value: {
            type: String,
            default: PaymentType.STRIPE
        }
    },
    computed: {
        selectedMethod: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        }
    },
    methods: {
        selectMethod(method) {
            if (method === PaymentType.We_CHAT || method === PaymentType.ALI_PAY || method === PaymentType.STRIPE) {
                this.selectedMethod = method;
            }
        }
    }
}
</script>

<style scoped>
.section-title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 10px;
    border-bottom: 2px solid #667eea;
    padding-bottom: 10px;
}

.payment-method {
    font-size: 14px;
    border: 2px solid #ddd;
    border-radius: 10px;
    padding: 10px 15px;
    margin-bottom: 10px;
    cursor: pointer;
    transition: all 0.3s;
}

.payment-method.selected {
    border-color: #667eea;
    background: #f8f9ff;
}

.payment-method.disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
</style>